/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TournamentUpdateTeamDto { 
    name: string;
    person1Name: string;
    person2Name: string;
    contactPhoneNumber: string;
    contactEmail: string;
    livesAt: TournamentUpdateTeamDto.LivesAtEnum;
}
export namespace TournamentUpdateTeamDto {
    export type LivesAtEnum = 'PFEILHEIM3A' | 'PFEILHEIM46' | 'EXTERN';
    export const LivesAtEnum = {
        Pfeilheim3A: 'PFEILHEIM3A' as LivesAtEnum,
        Pfeilheim46: 'PFEILHEIM46' as LivesAtEnum,
        Extern: 'EXTERN' as LivesAtEnum
    };
}


